import { ButtonComponent } from './components/basic/button/button.component';
import { ButtonPrimaryDirective } from './directives/button-primary.directive';
import { ButtonSecondaryDirective } from './directives/button-secondary.directive';
import { ButtonTertieryDirective } from './directives/button-tertiery.directive';
import { ButtonSubmitDirective } from './directives/button-submit.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Buttons = [
  ButtonComponent,
  ButtonPrimaryDirective,
  ButtonSubmitDirective,
  ButtonSecondaryDirective,
  ButtonTertieryDirective
];
